export enum SaveResultEnum {
    NotApplicable = 0,
    Success = 1,
    Failed = 2,
}